import { createReducer } from '../../../../store.model';

import { ActionType } from './commitment-narrative.action';
import { defaultState, State } from './commitment-narrative.state';
import { AddNote } from './state/add-note.action';
import { addNoteReducer } from './state/add-note.reducer';
import { ApplyFilters } from './state/filter.action';
import { applyFiltersReducer } from './state/filter.reducer';
import { Reload } from './state/reload.action';
import { reloadReducer } from './state/reload.reducer';
import { ToggleExpandNote } from './state/toggle-expand.action';
import { toggleExpandNoteReducer } from './state/toggle-expand.reducer';
import { UpdateOrRemoveNote } from './state/update-row.action';
import { updateOrRemoveNoteReducer } from './state/update-row.reducer';

const { reducer, builder } = createReducer<ActionType, State>(defaultState());

builder.add<Reload>(ActionType.COMMITMENT_NARRATIVE__RELOAD, reloadReducer);

builder.add<ApplyFilters>(
    ActionType.COMMITMENT_NARRATIVE__APPLY_FILTERS,
    applyFiltersReducer,
);
builder.add<AddNote>(ActionType.COMMITMENT_NARRATIVE__ADD_NOTE, addNoteReducer);
builder.add<ToggleExpandNote>(
    ActionType.COMMITMENT_NARRATIVE__TOGGLE_EXPAND_NOTE,
    toggleExpandNoteReducer,
);
builder.add<UpdateOrRemoveNote>(
    ActionType.COMMITMENT_NARRATIVE__UPDATE_OR_REMOVE_NOTE,
    updateOrRemoveNoteReducer,
);

export const commitmentNarrativeReducer = reducer;
